import * as reportsService from '@services/reports-service';

import { showError } from '@store/logged/actions';
import { successResponsive } from 'constants/errorObjects';
import * as actionTypes from './actionTypes';

export const setCurrentPage = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE,
  payload: page,
});

export const showSkeletonReport = () => ({
  type: actionTypes.SHOW_ON_SKELETON,
});

export const hideSkeletonReport = () => ({
  type: actionTypes.HIDE_ON_SKELETON,
});

export const setInitialState = () => ({
  type: actionTypes.SET_INITIAL_STATE,
  payload: {},
});

const setReports = (reports) => ({
  type: actionTypes.SET_REPORTS,
  payload: reports,
});

const setReportsFilteredByRange = (reports) => ({
  type: actionTypes.SET_REPORTS_FILTERED_BY_RANGE,
  payload: reports,
});

export const setReportsRangeToShow = (range) => ({
  type: actionTypes.SET_REPORTS_RANGE_TO_SHOW,
  payload: range,
});

export const setFilterReportsByType = ({ type }) => ({
  type: actionTypes.SET_REPORTS_FILTERED_BY_TYPE,
  payload: type,
});

export const setFilterReportsByRange =
  ({ filter: { dataRange }, accountId }) =>
  (dispatch) =>
    reportsService
      .getReportsByRange({ accountId, dataRange })
      .then((reports) => {
        dispatch(setReportsFilteredByRange(reports));
      })
      .catch((error) => {
        dispatch(showError({ ...error, title: error.title ?? 'Error al buscar los reportes' }));
      });

const deleteReportAction = (id) => ({
  type: actionTypes.DELETE_REPORT,
  payload: id,
});

export const openFlux = () => ({
  type: actionTypes.OPEN_NEW_REPORT_MODAL,
});

export const closeFlux = () => ({
  type: actionTypes.CLOSE_NEW_REPORT_MODAL,
});

export const openSpinner = () => ({
  type: actionTypes.OPEN_LOAD_SPINNER,
});

export const closeSpinner = () => ({
  type: actionTypes.CLOSE_LOAD_SPINNER,
});

export const fetchReports = (accountId) => (dispatch) =>
  reportsService
    .getReports(accountId)
    .then((reports) => {
      dispatch(setReports(reports));
    })
    .catch((error) => {
      dispatch(showError({ ...error, title: error.title ?? 'Error al buscar los reportes' }));
    })
    .finally(() => dispatch(hideSkeletonReport()));

export const createReport = (payload) => (dispatch) =>
  reportsService
    .createReport(payload)
    .then((repo) => {
      dispatch(fetchReports(repo.account_id));
      dispatch(
        showError(
          successResponsive(
            'Estamos creando tu reporte, accede al documento desde tus reportes en menú'
          )
        )
      );
    })
    .catch((error) => {
      dispatch(showError({ ...error, title: error.title ?? 'Error al generar el reporte' }));
    })
    .finally(() => {
      dispatch(closeFlux());
      dispatch(closeSpinner());
    });

export const scheduledReport = (payload) => (dispatch) =>
  reportsService
    .scheduledReport(payload)
    .then((repo) => {
      dispatch(fetchReports(repo.account_id));
      dispatch(
        showError(
          successResponsive(
            'Estamos creando tu reporte, accede al documento desde tus reportes en menú'
          )
        )
      );
    })
    .catch((error) => {
      dispatch(showError({ ...error, title: error.title ?? 'Error al generar el reporte' }));
    })
    .finally(() => {
      dispatch(closeFlux());
      dispatch(closeSpinner());
    });

export const deleteReport = (id) => (dispatch) =>
  reportsService
    .deleteReport(id)
    .then(() => {
      dispatch(deleteReportAction(id));
    })
    .catch((error) => {
      dispatch(showError({ ...error, title: error.title ?? 'Error al borrar el reporte' }));
    });

export const setFilter = (filter) => ({
  type: actionTypes.SET_FILTER_REPORT,
  payload: filter,
});

export const filterReports =
  ({ filter, accountId }) =>
  (dispatch) => {
    dispatch(setFilter(filter));
    dispatch(
      filter.dataRange
        ? setFilterReportsByRange({ filter, accountId })
        : setFilterReportsByType(filter)
    );
  };

export const resetFilter = () => ({
  type: actionTypes.RESET_FILTER_REPORT,
});
